import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-desicion',
  templateUrl: './desicion.component.html',
  styleUrls: ['./desicion.component.scss'],
})
export class DesicionComponent implements OnInit {
  text: any;

  constructor(
    public dialogRef: MatDialogRef<DesicionComponent>,
    public router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    let h3 = document.getElementsByTagName('H3').item(0);
    this.text = h3.innerHTML;
    //console.log(this.text.innerText);
  }
  ngOnInit(): void {
    if (this.data.text) {
      this.text = this.data.text
    }
  }
}
